import {
  type EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { AgUiChatTransport } from './ag-ui-chat-transport.service';

export function provideChat(): EnvironmentProviders {
  return makeEnvironmentProviders([AgUiChatTransport]);
}
